import axios from 'axios';
const API_URL = process.env.REACT_APP_BASE_URL || "https://bitesaver.ca/api";
const ApiClient = () => {
  
    const instance = axios.create({
        baseURL: API_URL ,
        headers: {
        'Content-Type':'application/json',
    }
    });
    const token = localStorage.getItem('accessToken');
        if (token) {
          instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
          delete instance.defaults.headers.common['Authorization'];
        }

    instance.interceptors.response.use(
        response => response,
        error => {
            if (error.response && error.response.status === 401) {
           
                        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("authUser");
                window.location.href = '/login';
            }
            return Promise.reject(error);
        }
    );
    return instance;
};
export default ApiClient;
